var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_824_13732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8683 31.9958L23.9329 23.9167C24.4724 23.3771 24.7787 22.6333 24.7787 21.8604V7.29167C24.7787 5.6875 23.4662 4.375 21.862 4.375H8.7516C7.58494 4.375 6.53494 5.075 6.08285 6.13958L1.32869 17.2375C0.0891032 20.125 2.20369 23.3333 5.3391 23.3333H13.5787L12.1933 30.0125C12.0474 30.7417 12.2662 31.4854 12.7912 32.0104C13.6516 32.8562 15.0224 32.8562 15.8683 31.9958ZM30.6266 4.375C29.0224 4.375 27.7099 5.6875 27.7099 7.29167V18.9583C27.7099 20.5625 29.0224 21.875 30.6266 21.875C32.2308 21.875 33.5433 20.5625 33.5433 18.9583V7.29167C33.5433 5.6875 32.2308 4.375 30.6266 4.375Z",
    fill: "#FF005B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_824_13732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/failIcon.b92e50e7.svg";
export { ForwardRef as ReactComponent };